import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import CardSeplag from "../../../../../components/CardSeplag";
import { buscarAnaliseAcaoDevolutiva, buscarAnaliseAcaoGeral } from "../../../../../service/Rag/lançamento/acao";
import AnaliseGeralSeplag from "./AnaliseAcaoGeral/AnaliseGeralAcaoSeplag";
import DevolutivaUnidadeSetorial from "./DevolutivaUnidadeAcaoSetorial/DevolutivaUnidadeAcaoSetorial";
import AnaliseGeralAcaoSeplag2024 from "./component-2024/AnaliseGeralAcaoSeplag2024";

const AnaliseProgramaAcaoSeplag = ({ dadosItemAcao, parametroExercicio, form }) => {
  const [data, setData] = useState({
    ListaAnaliseAcao: [],
    ListaAnaliseAcaoDevolutiva: [],
  });
  const [permissionUserAnaliseGeral, setPermissionUserAnaliseGeral] = useState({
    edit: false,
    view: false,
  });
  const [permissionUserDevolutiva, setPermissionUserDevolutiva] = useState({
    edit: false,
    view: false,
  });
  const [atualizarData, setAtualizarData] = useState(true);
  let history = useHistory();
  const userPerfil = useSelector((state) => state.userReducer.user);

  const permission = (parametroExercicio) => {
    let dateNow = new Date();
    let cronogramaVigente = "INATIVO";
    let podeEditarAnaliseGeral;
    let podeEditarDevolutiva;
    let statExercicio = "INATIVO";
    let view = false;
    let edit = false;
    const authorities = userPerfil.contaAcesso.authorities;

    for (let cronograma of parametroExercicio.cronograma) {
      let dataFinal = new Date(
        Number(cronograma.dataFinal.split("/")[2]),
        Number(cronograma.dataFinal.split("/")[1] - 1),
        Number(cronograma.dataFinal.split("/")[0])
      );
      if (dataFinal >= dateNow) cronogramaVigente = "ATIVO";
    }
    for (let i = 0; i < authorities.length; i++) {
      if (authorities[i].nomeRole === "MONRL_ADMIN_CENTRAL" || authorities[i].nomeRole === "MONRL_ANALISTA")
        podeEditarAnaliseGeral = true;
      if (authorities[i].nomeRole === "MONRL_ADMIN_SETORIAL") podeEditarDevolutiva = true;
    }
    if (parametroExercicio.exercicio.statExercicio === "ATIVO") statExercicio = "ATIVO";
    if (cronogramaVigente === "ATIVO" && podeEditarAnaliseGeral === true && statExercicio === "ATIVO") {
      view = true;
      edit = true;
    } else if (form.permissaoItem === "E" || userPerfil.contaAcesso.pessoa.idenPessoa === form.idenPessoaResp) {
      edit = false;
      view = true;
    }
    setPermissionUserAnaliseGeral({ view: view, edit: edit });

    view = true;
    edit = false;

    if (cronogramaVigente === "ATIVO" && podeEditarDevolutiva === true && statExercicio === "ATIVO") {
      view = true;
      edit = true;
    } else if (form.permissaoItem === "E" || userPerfil.contaAcesso.pessoa.idenPessoa === form.idenPessoaResp) {
      edit = true;
      view = true;
    }
    setPermissionUserDevolutiva({ view: view, edit: edit });
  };
  const voltar = () => {
    history.push({ pathname: "/raglancamentos", state: {} });
  };

  useEffect(() => {
    permission(parametroExercicio);

    if (atualizarData === true) {
      buscarAnaliseAcaoGeral(dadosItemAcao.idenPtaMonitora, 0).then((_res) => {
        setData((prevState) => ({
          ...prevState,
          listaAnaliseAcaototalPages: _res?.totalPages ? _res.totalPages : 0,
          listaAnalisetotalElements: _res?.totalElements ? _res.totalElements : 0,
          OrgCentralnumber: _res?.number,

          ListaAnaliseAcao: _res.content.sort((a, b) => {
            if (a.idenAnaliseAcao > b.idenAnaliseAcao) {
              return 1;
            }
            if (a.idenAnaliseAcao < b.idenAnaliseAcao) {
              return -1;
            }
            return 0;
          }),
        }));
      });

      buscarAnaliseAcaoDevolutiva(dadosItemAcao.idenPtaMonitora, 0).then((_res) => {
        setData((prevState) => ({
          ...prevState,
          listaAnaliseDevolutivaAcaototalPages: _res?.totalPages ? _res.totalPages : 0,
          listaAnaliseDevolutivatotalElements: _res?.totalElements ? _res.totalElements : 0,
          devolutivanumber: _res?.number,
          ListaAnaliseAcaoDevolutiva: _res.content.sort((a, b) => {
            if (a.idenAnaliseAcao > b.idenAnaliseAcao) {
              return 1;
            }
            if (a.idenAnaliseAcao < b.idenAnaliseAcao) {
              return -1;
            }
            return 0;
          }),
        }));
      });
      setAtualizarData(false);
    }
  }, [atualizarData]);

  return (
    <CardSeplag>
      <ConfirmDialog breakpoints={{ "960px": "75vw", "640px": "100vw" }} style={{ width: "50vw" }} />
      {parametroExercicio.exercicio.ano >= 2024 ? (
        <AnaliseGeralAcaoSeplag2024
          setAtualizarData={setAtualizarData}
          dadosItemAcao={dadosItemAcao}
          permissionUser={permissionUserAnaliseGeral}
          ListaAnaliseAcaoDevolutiva={data.ListaAnaliseAcaoDevolutiva}
          setData={setData}
          data={data}
        />
      ) : (
        <>
          <AnaliseGeralSeplag
            ListaAnaliseAcao={data.ListaAnaliseAcao}
            setAtualizarData={setAtualizarData}
            dadosItemAcao={dadosItemAcao}
            permissionUser={permissionUserAnaliseGeral}
          />
          <DevolutivaUnidadeSetorial
            ListaAnaliseAcaoDevolutiva={data.ListaAnaliseAcaoDevolutiva}
            setAtualizarData={setAtualizarData}
            dadosItemAcao={dadosItemAcao}
            permissionUser={permissionUserDevolutiva}
            data={data}
          />
        </>
      )}

      <div className="p-fluid grid " style={{ margin: "1rem" }}>
        <div className="field col-12 md:col-8 ">&nbsp;</div>
        <div className="field col-12 md:col-2 "></div>

        <div className="field col-12 md:col-2 ">
          <Button label="Voltar" className="p-button-secondary" onClick={voltar} />
        </div>
      </div>
    </CardSeplag>
  );
};
export default AnaliseProgramaAcaoSeplag;
